import { render, staticRenderFns } from "./MarketplaceLayout.vue?vue&type=template&id=106eef9f&scoped=true&"
import script from "./MarketplaceLayout.vue?vue&type=script&lang=js&"
export * from "./MarketplaceLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106eef9f",
  null
  
)

export default component.exports